export enum InquiryTypes {
  Marketing = 'Marketing',
  Partnerships = 'Partnerships',
  PR = 'PR',
  General = 'General Inquiry',
}
